import { of } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { Injector } from '@angular/core';
import { ProfilePathItemDTO } from '../../../../dto/educational-path/profile-path-item.dto';

export function profile_paths_location(componentDataSourceService: ComponentDataSourceService & { injector: Injector }) {
    return {
        name: 'Lokation',
        description: 'Uddannelser og vedligeholdelse fra din lokation',
        execute: () => {
            return of<ProfilePathItemDTO[]>([]); // Return empty array as location-specific paths are not implemented yet
        },
        settings: {
            columns: [
                { 
                    key: 'name', 
                    header: 'Modul', 
                    type: 'text-with-subtitle',
                    subtitle: 'subtypes'
                },
                { key: 'participation_status', header: 'Status', type: 'text' },
                { key: 'type', header: 'Type', type: 'text' },
                {
                    key: 'module_name',
                    header: '',
                    type: 'button',
                    buttonText: 'Find tilmelding',
                    buttonColor: 'primary',
                    variant: 'raised',
                    alignment: 'right',
                    action: (row: any) => {
                        const searchParams = new URLSearchParams({
                            search: row.module_name,
                            type: 'module'
                        });
                        window.location.href = `/events?${searchParams.toString()}`;
                    }
                }
            ],
            pageable: false,
            sortable: false,
            rowHover: true,
            defaultSortColumn: 'name',
            defaultSortDirection: 'asc'
        }
    };
} 